import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mt-2",
  style: {"user-select":"none"}
}
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "mr-1" }
const _hoisted_4 = {
  key: 1,
  style: {"user-select":"none"},
  class: "mt-1"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "mr-1" }

import {computed} from "vue";
import DateHelper from "~/ts/library/Date";


const __default__ = {
    name: "DateTimeInputControls"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: /*@__PURE__*/_mergeModels({
    site: {}
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {

let props = __props;

let model = _useModel<string>(__props, "modelValue");


let suggests = computed(() => {
    return props.site.delayMessageSuggests;
});

function applyDate(date: Date) {
    model.value = (new DateHelper(date)).toMysqlFormat();
}

function applySuggest(seconds: number) {
    let date = new Date();
    date.setSeconds(date.getSeconds() + seconds);
    applyDate(date);
}

function addSuggest(seconds: number) {
    let date = new Date(model.value);
    date.setSeconds(date.getSeconds() + seconds);
    applyDate(date);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(suggests))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _cache[0] || (_cache[0] = _createElementVNode("span", { style: {"display":"inline-block","min-width":"6em"} }, "Через", -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(suggests), (item, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
              _createElementVNode("a", {
                class: "link-dashed ml-1",
                tabindex: "",
                onClick: ($event: any) => (applySuggest(item.addSeconds))
              }, _toDisplayString(item.descr), 9, _hoisted_2),
              _createElementVNode("span", _hoisted_3, _toDisplayString(index < _unref(suggests).length - 1 ? ', ' : ''), 1)
            ], 64))
          }), 256))
        ]))
      : _createCommentVNode("", true),
    (_unref(suggests))
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _cache[1] || (_cache[1] = _createElementVNode("span", { style: {"display":"inline-block","min-width":"6em"} }, "Добавить", -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(suggests), (item, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
              _createElementVNode("a", {
                class: "link-dashed ml-1",
                tabindex: "",
                onClick: ($event: any) => (addSuggest(item.addSeconds))
              }, _toDisplayString(item.descr), 9, _hoisted_5),
              _createElementVNode("span", _hoisted_6, _toDisplayString(index < _unref(suggests).length - 1 ? ', ' : ''), 1)
            ], 64))
          }), 256))
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})